import { Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TransportTermList } from './bag-transport-term.model';

@Injectable({
	providedIn: 'root',
})
export class TransportTermMatDataService {
	readonly matData = new MatTableDataSource<TransportTermList>();
}
